import React from 'react';
import { Link } from 'react-router-dom';
import { format } from "date-fns";
import { sv } from 'date-fns/locale'
import './styles.scss';


const Img = (props) => {
    if (props.images && props.images.length > 0) {
        const img = props.images[0];
        return (
            <div className="blog-items__item-image--no-image">
                <div className="blog-items__item-image-date">
                    <span className="blog-items__item-image-date-day">{format(new Date(props.publishedOn),'dd')}</span>
                    <span className="blog-items__item-image-date-month">{format(new Date(props.publishedOn),'MMMM', {locale: sv})}</span>
                </div>
                <img className="blog-items__item-image"  src={img.filePath} alt={props.header} />
            </div>
        );
    } else {
        return (
            <div className="blog-items__item-image--no-image">
                <div className="blog-items__item-image-date">
                    <span className="blog-items__item-image-date-day">{format(new Date(props.publishedOn),'dd')}</span>
                    <span className="blog-items__item-image-date-month">{format(new Date(props.publishedOn),'MMMM', {locale: sv})}</span>
                </div>
            </div>
        );
    } 
}

const Post = (props) => {
    return (
        <Link to={`/news/${props.slug}`}
           className="blog-items__item"
           title={props.header}>
            <Img {...props} />
            <div className="blog-items__item-date">
                {format(new Date(props.publishedOn),'yyyy-MM-dd')}
            </div>
            <h2 className="blog-items__item-heading">{props.header}</h2>
        </Link>
    ); 
};

const Posts = (props) => {   
    return (
        <> 
            <div className="blog-items__posts">
                {props.posts && props.posts.map((post, i) => {
                    return <Post key={i} {...post} />;
                })}
            </div>
        </>
    );
};

export default Posts;